import {useCallback, useEffect} from 'react';
import {Typography} from '~library/atoms/Typography';
import {PopOver} from '~library/molecules/PopOver';
import {InfoIcon} from '~library/svg/InfoIcon';
import {cdnPath, charcoal, coin, cottonCandy} from '~libSass/base/_exports.sass';

export const ProductLinkInfoButton = ({dataQaId, uuid}) => {
  const indexValue = dataQaId.slice(dataQaId.length - 1);
  const popoverKey = `show_popover_product-link-info-popover`;
  const showLocal = window.localStorage.getItem(popoverKey);

  const showOnceCallback = useCallback(() => {
    window.localStorage.setItem(popoverKey, 'false');
  }, []);

  useEffect(() => {
    if (showLocal !== 'false') {
      if (showLocal === null || showLocal > indexValue) {
        window.localStorage.setItem(popoverKey, indexValue);
      }
    }
  }, [showLocal, indexValue]);

  return (
    <PopOver
      id={`${popoverKey}-${uuid}`}
      buttonId={`product-link-info-${dataQaId}`}
      position="bottom"
      bkgColor={cottonCandy}
      textColor={charcoal}
      className="product-link-info-trigger"
      contentClassName="product-link-info-popover-content-wrapper"
      arrowClassName="product-link-info-arrow"
      closeOnOutsideClick
      showCloseButton
      showOnce
      closeButtonCallback={showOnceCallback}
      data-qa-id="product-link-info"
      buttonClassName="product-link-info__button"
      buttonContent={<InfoIcon ratio={1.25} color={coin} />}
      cookieKey={popoverKey}
    >
      <div className="product-link-info-popover-content">
        <Typography
          className="product-link__popover-header"
          variant="header5"
          as="h3"
        >{`Let 'em know exactly what you need`}</Typography>
        <video
          className="popover-link-info-video"
          autoPlay
          muted
          loop
          playsInline
          controls={false}
          aria-label="Paste or type in a link to your desired product for volunteers to purchase"
        >
          <source
            src={`${cdnPath}signup-sheets/product-info/product-link-demo.mp4`}
            type="video/mp4"
          />
        </video>
      </div>
    </PopOver>
  );
};
